enum BenachrichtigungsLevel {
	TIPP = "tip",
	INFO = "info",
	WARNUNG = "warning",
	ERFOLG = "success",
	ALARM = "alert",
	ASYNC = "async",
}

export default BenachrichtigungsLevel
